<template>
  <div class="page page-free-index">
    <product-list :main-block="mainBlock"
    />
  </div>
</template>

<script>
  import ProductList from '@/components/Product/BlockList';
  import { getAudioFreeIndex } from '@/services/audio';

  export default {
    name: 'PageFreeIndex',
    metaInfo: {
      title: '免费专区',
    },
    components: {
      ProductList,
    },
    data() {
      return {
        mainBlock: [],
      };
    },
    methods: {
      async fetchData() {
        const data = await getAudioFreeIndex();
        this.mainBlock = data.mainBlock;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  /deep/ .product-main-block-component {
    .block-component {
      &:first-child {
        margin-top: 0;
      }
    }
  }
</style>
